import ClientSideAppLoader from './ClientSideAppLoader';
import ServerSideAppLoader from './ServerSideAppLoader';

const isBrowserContextAvailable = typeof document !== 'undefined';
export default isBrowserContextAvailable
  ? new ClientSideAppLoader()
  : new ServerSideAppLoader();
